import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ToastViewport } from "@/components/ui/toast";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AdminRoute } from "@/components/AdminRoute";
import { AppLayout } from "@/components/AppLayout";

const LoginPage = lazy(() => import("@/pages/LoginPage"));
const ChangePasswordPage = lazy(() => import("@/pages/ChangePasswordPage"));
const DashboardPage = lazy(() => import("@/pages/DashboardPage"));
const BoardPage = lazy(() => import("@/pages/BoardPage"));
const JoinPage = lazy(() => import("@/pages/JoinPage"));
const PreLobbyPage = lazy(() => import("@/pages/PreLobbyPage"));
const ReviewPage = lazy(() => import("@/pages/ReviewPage"));
const PrivacyPage = lazy(() => import("@/pages/PrivacyPage"));
const UsersPage = lazy(() => import("@/pages/admin/UsersPage"));
const UserFormPage = lazy(() => import("@/pages/admin/UserFormPage"));

function LoadingFallback() {
  return (
    <div className="flex h-full w-full items-center justify-center text-muted-foreground">
      Loading…
    </div>
  );
}

export default function App() {
  return (
    <>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/join/:code" element={<JoinPage />} />
          <Route path="/lobby/:code" element={<PreLobbyPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/change-password" element={<ChangePasswordPage />} />
            <Route element={<AppLayout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/board/:id" element={<BoardPage />} />
              <Route path="/review" element={<ReviewPage />} />
              <Route path="/review/:id" element={<ReviewPage />} />
              <Route element={<AdminRoute />}>
                <Route path="/admin/users" element={<UsersPage />} />
                <Route path="/admin/users/new" element={<UserFormPage />} />
                <Route path="/admin/users/:id" element={<UserFormPage />} />
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
      <ToastViewport />
    </>
  );
}
